<template>
    <div class="certificate-list-page">
        <div v-if="loading" class="loading-state">
            <van-loading type="spinner" color="#00BCD4">加载中...</van-loading>
        </div>

        <div v-else-if="list.length === 0" class="empty-state">
            <van-empty description="暂无培训证明" />
        </div>

        <div v-else class="list-wrap">
            <div class="card-item" v-for="(item, index) in list" :key="item.id || index">
                <div class="card-header">
                    <img class="card-icon" src="~@/assets/image/my-item-04.png" alt="">
                    <span class="card-title">{{ item.title || item.testPaperTitle || '培训证明' }}</span>
                </div>
                <div class="card-footer">
                    <div class="status-wrap">
                        <img class="pass-icon" src="~@/assets/image/training-pass-icon.png" alt="">
                        <span>考试已通过</span>
                    </div>
                    <van-button type="info" size="small" round @click="viewCertificate(item)">
                        查看证书
                    </van-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getTrainList } from '@/api/index.js';

export default {
    name: 'CertificateList',
    data() {
        return {
            loading: false,
            list: []
        };
    },
    mounted() {
        this.loadList();
    },
    methods: {
        async loadList() {
            if (this.loading) return;
            this.loading = true;
            try {
                const res = await getTrainList();
                this.list = res.data || [];
            } finally {
                this.loading = false;
            }
        },
        viewCertificate(item) {
            if (!item.answerId) {
                this.$toast('缺少答卷ID');
                return;
            }
            this.$router.push({
                path: '/my/certificate',
                query: { answerId: item.answerId }
            });
        }
    }
};
</script>

<style scoped lang="scss">
.certificate-list-page {
    min-height: 100vh;
    background: #eef7f8;
    padding: 12px;
    box-sizing: border-box;
}

.list-wrap {
    padding-bottom: 16px;
}

.card-item {
    background: #fff;
    border-radius: 12px;
    padding: 14px;
    margin-bottom: 12px;
}

.card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
}

.card-icon {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.card-title {
    font-size: 16px;
    color: #333;
    font-weight: 600;
}

.card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.status-wrap {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #999;
    font-size: 12px;
}

.pass-icon {
    width: 12px;
    height: 14px;
}

::v-deep .van-button {
    background: #46ccdc;
    border-color: #46ccdc;
    height: 28px;
    padding: 0 14px;
    font-size: 12px;
}

.loading-state,
.empty-state {
    padding-top: 60px;
    text-align: center;
}
</style>
